//+-------------------------------------------------
// Node Modules Import
//+-------------------------------------------------
// import gsap from 'gsap';
// import ScrollTrigger from 'gsap/ScrollTrigger';

//gsap.registerPlugin(ScrollTrigger);

//+-------------------------------------------------
// gsapHoverAnimation()
// Trigger animations individually for each
// data-gsaphv child depending on attribute
//+-------------------------------------------------
function gsapHoverAnimation() {
  //    let gsaphvAnimationEle = gsap.utils.toArray($('[data-gsaphv-animation]'));
  const dataGsaphvAnimation = document.querySelectorAll('[data-gsaphv-animation]');
  let gsaphvAnimations = gsap.utils.toArray(dataGsaphvAnimation);
  // Animation Loop
  gsaphvAnimations.forEach((gsaphvAnimationEle) => {
    console.log('gsaphvAnimationEle:', gsaphvAnimationEle);
    // get img element within gsaphvAnimationEle
    let gsaphvAnimationImg = gsaphvAnimationEle.querySelector('img');
    let animation = gsap.to(gsaphvAnimationImg, {
      paused: true,
      y: -16,
    });
    // on mouse enter play animation and console.log('mouseenter')
    gsaphvAnimationEle.addEventListener('mouseenter', () => {
      animation.play();
      console.log('mouseenter');
    });
    gsaphvAnimationEle.addEventListener('mouseleave', () => animation.reverse());
  });
}
function hoverAnimations() {
  window.setTimeout(() => {
    // Stop execution when no swiper element has been found
    //if ($('[data-gsaphv-animation]').length === 0) {
    // vanila js conversion of above line
    if (document.querySelectorAll('[data-gsaphv-animation]').length === 0) {
      return;
    }
    console.log('gsapHoverAnimation()');
    // Initialize execution if any data-gsaphv-animation has been found
    gsapHoverAnimation();
  }, 300);
}

// -- Initial execution
// Runs selected functions on jQuery window.ready
//+--------------------------------
//$(function() {
//   hoverAnimations();
//});

// fire hoverAnimations() when dom is loaded
document.addEventListener('DOMContentLoaded', hoverAnimations);
